// Costanti condivise Rapportino (allineate a backend/models/rapportino.py)
export const TIPI_INTERVENTO = [
  'Censimento, attivazione e verifica periodica RT',
  'Attivazione e verifica periodica RT',
  'Verifica periodica RT',
  'Manutenzione straordinaria RT',
  'Variazione dati intestazione/Ubicazione RT',
  'Sostituzione memoria di dettaglio (EX DGFE)',
  'Aggiornamento Firmware/Software RT',
  'Disattivazione RT',
  'Dismissione RT',
  'Altro',
];

export const CHECKLIST_VP = {
  '1. Esame visivo RT': [
    ['1.1', 'Integrità Modulo Fiscale (Involucro RT)'],
    ['1.2', 'Presenza, conformità ed integrità della targhetta identificativa'],
    ['1.3', 'Presenza sigillo fiscale'],
    ['1.4', 'Presenza e conformità formato QR Code'],
    ['1.5', 'Lettura QR Code: corrispondenza dati con targhetta'],
    ['1.6', 'Lettura QR Code: coerenza dati identificativi esercente'],
  ],
  '2. Prove di corretto funzionamento': [
    ['2.1', 'Verifica versione firmware da lettura QR Code'],
    ['2.2', 'Identificazione versione firmware installata su RT'],
    ['2.3', "La versione firmware è l'ultima dichiarata dal produttore?"],
    ['2.4', 'Aggiornamento firmware (se necessario)'],
    ['2.5', "Funzionalità hardware: tasti / tastiera d'emergenza"],
    ['2.6', 'Funzionalità hardware: display cliente e operatore'],
    ['2.7', 'Verifica conoscenza utente accesso riservato dati'],
    ['2.8', 'Documento gestionale di chiusura pre-intervento'],
    ['2.9', 'Emissione di almeno 2 documenti commerciali di prova'],
    ['2.10', 'Documenti di annullo o reso totale di prova'],
    ['2.11', 'Qualità di stampa e struttura documento (D.M. MEF 07.12.2016)'],
    ['2.12', 'Chiusura giornaliera: coerenza numeri e corrispettivo'],
    ['2.13', 'Invio XML corrispettivi AdE con ESITO POSITIVO'],
    ['2.14', 'Stampa memoria di dettaglio (DGFE) e verifica'],
  ],
  '3. RT su aree pubbliche': [
    ['3.1', 'Copertura tastiera a tenuta stagna (se prevista)'],
    ['3.2', 'Indicatore stato di carica batteria funzionante'],
    ['3.3', 'Collegamenti elettrici protetti e non pericolosi'],
  ],
  '4. Chiusura intervento su RT': [
    ['4.1', 'Inserimento dati tecnico abilitato (C.F.) e laboratorio (P.IVA)'],
    ['4.2', "Registrazione su RT dell'esito della verificazione"],
    ['4.3', 'Documento gestionale a chiusura intervento'],
  ],
};

export const NATURE_IVA = ['N1', 'N2', 'N3', 'N4', 'N5', 'N6', 'VI', '-'];
